import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import CardHeader from '@mui/material/CardHeader';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Rating from '@mui/material/Rating';
import { count, round } from "@components/config/helpers";
import { alpha, useTheme } from '@mui/material/styles';
import P, { Span, Strong } from "@components/Components/Reusables/Typography/P";

const ProductReviews = (props) => { //TODO: dispatch a request to grab the reviews
    const {
        product_id,
        reviews
    } = props;

    const theme = useTheme();
    const [reviewIndex, setReviewIndex] = useState(4);

    const increseReviewIndex = () => {
        setReviewIndex((prevState) => prevState + 4)
    }

    useEffect(() => {
        // console.log(reviewIndex)
    }, [reviewIndex])

    const RenderCardHeaderTitle = ({ customer_name, rating }) => (
        <Grid container>
            <Grid xs={12} sm={6} item>
                <h5 className="m-0">{customer_name}</h5>
            </Grid>
            <Grid className="text-end" xs={12} sm={6} item>
                <Rating name="read-only" precision={0.5} value={round(rating)} readOnly />
            </Grid>
        </Grid>
    )

    return (
        <div>
            <Grid spacing={1} container>
                {reviews.map((review, idx) => {
                    return (
                        idx < reviewIndex && (
                            <Grid
                                key={idx}
                                xs={12}
                                sm={6}
                                md={4}
                                item
                            >
                                <Box
                                    className="p-2"
                                    sx={{
                                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                        border: `1px solid var(--color-primary)`,
                                        borderRadius: '12px'
                                    }}
                                >
                                    <Box>
                                        <P color='secondary.light'>{review.comment}</P>
                                    </Box>
                                    <Box>
                                        <Rating name="read-only" precision={0.5} value={round(review.rating)} readOnly />
                                    </Box>
                                    <Box className='d-flex'>
                                        <Strong className='fs-12' color='primary'>{review.customer_name}</Strong>
                                        <Span color='secondary' className='ml-2 fs-12'>{review.date}</Span>
                                    </Box>
                                </Box>
                            </Grid>
                        )
                    )
                })}
            </Grid>
            {reviewIndex < count(reviews) && <Button onClick={increseReviewIndex} className="mt-3 ml-2" variant="contained">Load More</Button>}
        </div>
    )
}

export default ProductReviews